/* eslint-disable react/jsx-boolean-value */
import {
  Checkbox, Flex, Input, Radio,
} from "antd";
import { Control, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormItem from "@/components/FormItem";
import { NAMESPACES } from "@/constants/i18next.constants";

import { TBillingOnboardingForm } from "../../MultiStepForm.types";

type TThirdStepProps = {
  control: Control<TBillingOnboardingForm>;
  watch: UseFormWatch<TBillingOnboardingForm>;
};

function ThirdStep({ control, watch }: TThirdStepProps) {
  const { t } = useTranslation([NAMESPACES.BILLING_ONBOARDING, NAMESPACES.COMMON]);

  const watchIsPrivate = watch("isPrivate");
  const watchIsFixedMargin = watch("isFixedMargin");

  return (
    <>
      <FormItem
        name="isMediumVoltage"
        control={control}
        label={t("billingOnboarding.isMediumVoltage.label")}
        valuePropName="checked"
      >
        <Radio.Group>
          <Radio value={false}>{t("billingOnboarding.isMediumVoltage.lowVoltage")}</Radio>
          <Radio value={true}>{t("billingOnboarding.isMediumVoltage.mediumVoltage")}</Radio>
        </Radio.Group>
      </FormItem>
      <FormItem
        name="isMultiTerm"
        control={control}
        label={t("billingOnboarding.isMultiTerm.label")}
        valuePropName="checked"
      >
        <Radio.Group>
          <Radio value={false}>{t("billingOnboarding.isMultiTerm.singleTerm")}</Radio>
          <Radio value={true}>{t("billingOnboarding.isMultiTerm.multiTerm")}</Radio>
        </Radio.Group>
      </FormItem>
      <FormItem
        name="isGreen"
        control={control}
        label={t("billingOnboarding.isGreen")}
        valuePropName="checked"
      >
        <Checkbox>
          {t("yes", {
            ns: NAMESPACES.COMMON,
          })}
        </Checkbox>
      </FormItem>
      <FormItem
        name="isPrivate"
        control={control}
        label={t("billingOnboarding.isPrivate.label")}
        valuePropName="checked"
      >
        <Radio.Group>
          <Radio value={false}>{t("billingOnboarding.isPrivate.retailCompany")}</Radio>
          <Radio value={true}>{t("billingOnboarding.isPrivate.freeMarketUser")}</Radio>
        </Radio.Group>
      </FormItem>
      {watchIsPrivate
        ? (
          <Flex gap={4}>
            <FormItem
              name="isFixedMargin"
              control={control}
              valuePropName="checked"
            >
              <Radio.Group
                style={{
                  display: "flex",
                }}
                options={[
                  {
                    label: t("billingOnboarding.percent"),
                    value: false,
                  },
                  {
                    label: t("billingOnboarding.decimal"),
                    value: true,
                  },
                ]}
                optionType="button"
                buttonStyle="solid"
              />
            </FormItem>
            <FormItem
              name="margin"
              control={control}
              valuePropName="checked"
            >
              <Input
                placeholder={t(
                  watchIsFixedMargin
                    ? "billingOnboarding.decimalPlaceholder"
                    : "billingOnboarding.percentPlaceholder",
                )}
              />
            </FormItem>
          </Flex>
        )
        : (
          <FormItem
            name="isMultiTime"
            control={control}
            label={t("billingOnboarding.isMultiTime.label")}
            valuePropName="checked"
          >
            <Radio.Group>
              <Radio value={false}>{t("billingOnboarding.isMultiTime.singleStroke")}</Radio>
              <Radio value={true}>{t("billingOnboarding.isMultiTime.multipleStroke")}</Radio>
            </Radio.Group>
          </FormItem>
        )}
    </>
  );
}

export default ThirdStep;
